var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_61149940"]},_vm.$listeners),[_c('cube-button',{attrs:{"primary":"","disabled":""}},[_vm._v("置灰态")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }